import React from "react";

import { Text } from "@performyard/py-components";

type WizardStepHeaderProps = {
	title: string;
	subtitle: string;
};

/** The centered title/subtitle pair every wizard step opens with. */
export const WizardStepHeader = ({ title, subtitle }: WizardStepHeaderProps) => (
	<>
		<Text size="sub-heading" weight="semi-bold" color="neutral-9" dangerouslySetClassName="text-center">
			{title}
		</Text>
		<Text size="paragraph-2" color="neutral-9" dangerouslySetClassName="text-center">
			{subtitle}
		</Text>
	</>
);

type WizardStepWrapperProps = WizardStepHeaderProps & {
	children?: React.ReactNode;
	/** Width of the step body. Steps that render a full-width table pass their own. */
	maxWidthClassName?: string;
};

/** `WizardStepHeader` plus a width-constrained body — the default step layout. */
export const WizardStepWrapper = ({
	title,
	subtitle,
	children,
	maxWidthClassName = "max-w-[512px]",
}: WizardStepWrapperProps) => (
	<div className="flex flex-col items-center">
		<WizardStepHeader title={title} subtitle={subtitle} />
		{children && <div className={`mt-8 w-full ${maxWidthClassName}`}>{children}</div>}
	</div>
);
